import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { Flex, FormControl, FormErrorMessage, FormLabel, Input, useDisclosure } from "@chakra-ui/react";
import { LOCALE_PT_BR } from "../../../../constants/date-time";
import { FilterContainer } from "../../../../components/Tables/FilterContainer";
import DateTime from "react-datetime";

export const FilterPrintDocumentBatch = (props) => {
    const { t } = useTranslation('common');
    const { onFilter } = props;
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState("");
    const [point, setPoint] = useState("");
    const { isOpen, onToggle } = useDisclosure();

    const isStartDateInvalid = startDate ? startDate > new Date() : false;
    const isEndDateInvalid = startDate && endDate ? endDate <= startDate : false;

    const onFilterHandler = () => {
        onFilter({
            data_inicial: startDate ? new Date(startDate).toLocaleDateString(LOCALE_PT_BR) : "",
            data_final: endDate ? new Date(endDate).toLocaleDateString(LOCALE_PT_BR) : "",
            id_ponto_permissionario: point,
        });
    }

    const onClearHandler = () => {
        setStartDate("");
        setEndDate("");
        setPoint("");
        onFilter({
            data_inicial: null,
            data_final: null,
            id_ponto_permissionario: null,
        });
    };

    return (
        <FilterContainer
            w='125px'
            fontSize='sm'
            fontWeight='bold'
            variant="light"
            isOpen={isOpen}
            onToggle={onToggle}
            onFilter={onFilterHandler}
            onClear={onClearHandler}
        >
            <Flex w="100%" gap="4" justify="space-between">
                <FormControl w="230px" isInvalid={isStartDateInvalid}>
                    <FormLabel>
                        {t("system.labels.start-date")}
                    </FormLabel>
                    <DateTime
                        locale="pt-br"
                        closeOnSelect
                        timeFormat={false}
                        value={startDate}
                        inputProps={startDate ? undefined : { value: new Date() }}
                        renderInput={(props) => <Input {...props} />}
                        onChange={date => setStartDate(date)} />
                    <FormErrorMessage>
                        {t("system.messages.errors.invalid-start-date")}
                    </FormErrorMessage>
                </FormControl>

                <FormControl w="230px" isInvalid={isEndDateInvalid}>
                    <FormLabel>
                        {t("system.labels.end-date")}
                    </FormLabel>
                    <DateTime
                        locale="pt-br"
                        closeOnSelect
                        timeFormat={false}
                        inputProps={endDate ? undefined : { value: "" }}
                        renderInput={(props) => <Input {...props} />}
                        onChange={date => setEndDate(date)} />
                    <FormErrorMessage>
                        {t("system.messages.errors.invalid-end-date")}
                    </FormErrorMessage>
                </FormControl>

                <FormControl>
                    <FormLabel>
                        {t("permittees.details.tab-general.number")}
                    </FormLabel>
                    <Input
                        value={point}
                        onChange={e => setPoint(e.currentTarget.value)} />
                </FormControl>
            </Flex>
        </FilterContainer>
    )
}
